<div class="relative size-full">
  <rid-assignment-background />

  <div class="absolute inset-0 grid items-center justify-items-end p-8 pr-16">
    <div class="relative w-full max-w-4xl">
      @if (hasPlacedCurrentReward()) {
        <rid-button class="absolute right-0 -bottom-16 z-10" content="Ga verder" (click)="close()" />
      }

      <div class="max-h-[80vh] w-full" style="aspect-ratio: 16 / 10">
        <app-nine-sliced-container
          [url]="bookUrl()"
          [size]="bookSize()"
          [contentBox]="bookContentBox()"
          [paddingBox]="bookPaddingBox()"
          [scale]="bookScale()"
        >
          <div #contentEl class="relative size-full">
            <div class="font-default pointer-events-none absolute top-6 left-0 w-1/2 text-center text-3xl text-black/80">
              {{ weekLabel() }}
            </div>

            @for (entry of bookRewards(); track entry.key) {
              @let visuals = visualsFor(isDraggingEntry(entry), entry.placed ? entry.placed.rotation : restRotation);
              <rid-draggable
                class="absolute"
                [juice]="false"
                [style.left]="entry.placed ? entry.placed.x + 'px' : floatingRestLeft"
                [style.top]="entry.placed ? entry.placed.y + 'px' : floatingRestTop"
                style="transform: translate(-50%, -50%)"
                [style.z-index]="zIndexFor(entry)"
                (started)="onRewardDragStarted(entry)"
                (moved)="onRewardMoved(entry, $event[1])"
                (released)="onRewardReleased(entry, $event)"
              >
                <img
                  [src]="$lpApiService.getAssetUrl(entry.reward.image)"
                  [alt]="entry.reward.name"
                  [class]="'block w-auto object-contain transition-transform duration-300 ' + visuals.shadowClass"
                  [style.height.px]="rewardHeightFor(entry.reward)"
                  [style.rotate]="visuals.rotation + 'deg'"
                  [style.scale]="visuals.scale"
                  style="max-width: unset"
                />
              </rid-draggable>
            }

            <rid-scrapbook-drawing [week]="scrapbook.currentWeekIndex()" />
            @if (drawingTool(); as tool) {
              <rid-scrapbook-drawing-input [week]="scrapbook.currentWeekIndex()" [tool]="tool" />
            }
          </div>
        </app-nine-sliced-container>
      </div>
    </div>
  </div>

  <rid-drawing-tray class="absolute bottom-0 left-1/2 z-20 -translate-x-1/2" [(tool)]="drawingTool" />
</div>
